import React, { useEffect, useState } from 'react'
// styles 
import * as TimelineSidebarStyles from "./timeline-sidebar-styles"

// icons
import { IoCloseCircle } from "react-icons/io5";

import QRCode from "react-qr-code";
import { Button, ButtonGroup } from 'react-bootstrap';

//redux
import { useDispatch, useSelector } from 'react-redux';
import { setShowTimelineSidebar, setTimelineRoute } from '_redux/slices/timeline/timeline-control';
import { getAndroidAppVersion, selectAndroidAppVersion } from '_redux/slices/timeline/employees';
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { setShowToast, setToast } from '_redux/slices/timeline/timeline-toast';

//custom components
import AllFlightsSwitch from './all-flights-switch';
import ExpandAllFlightsSwitch from './expand-all-flights-switch';
import RampBookingsSwitch from './ramp-bookings-switch';
import PreBoardSwitch from './pre-board-switch';
import AutoAcceptUnplannedTask from './auto-accept-task';
import RowsPerPage from './rows-per-page';
import AutoCheckInLocation from './auto-checkin-location';
import ThirtyMinLayoutSwitch from './thirtyMin-layout-switch';
import DarkModeToggle from './dark-mode-toggle'
import LayoutSwitch from './layout-switch';
import RemovePaxPrefix from './remove-pax-prefix';
// import ViewAppTasks from './view-app-tasks';
import MarshallTaskSwitch from './marshall-task-switch';
import TimelineAppSettings from './timeline-app-settings';

const TimelineSidebar = () => {

    //#region redux
    const dispatch = useDispatch();
    const dbUser = useSelector(selectFirebaseInfo);                                       // logged in user
    const androidAppVersion = useSelector(selectAndroidAppVersion);
    const usedTheme = useSelector(selectUsedTheme);

    const appSettingIataList = ["DUB", "JER"];


    useEffect(() => {
        dispatch(getAndroidAppVersion(dbUser.details.authority))
    }, [])

    //#endregion
    const handleCopyURL = () => {
        navigator.clipboard.writeText(androidAppVersion.url)
        dispatch(setToast({
            message: "Copy Link successfully",
            statusType: "success",
        }));
        dispatch(setShowToast(true));
    }


    return (
        <div style={{ ...TimelineSidebarStyles.mainContainer, backgroundColor: usedTheme?.BACKGROUND_COLOR, borderColor: usedTheme?.BORDER_COLOR, color: usedTheme?.TEXT_COLOR }}>

            {/* header section */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                    <h4 style={{ fontWeight: '600', marginBottom: '4px' }}>Control Panel</h4>
                    <p style={{ fontSize: '14px', color: 'gray', margin: 0 }}>Timeline Settings</p>
                </div>
                <IoCloseCircle
                    size={34}
                    onClick={() => dispatch(setShowTimelineSidebar(false))}
                    cursor="pointer"
                    style={TimelineSidebarStyles.icon}
                    color="#abaaaa"
                />
            </div>
            <hr />

            <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>

                {/* layout mode switch 
                <LayoutSwitch />
                */}

                {/*display all flights switch */}
                <AllFlightsSwitch />

                {/* 30 min layout switch */}
                <ThirtyMinLayoutSwitch />

                {/*expand all flights switch 
                <ExpandAllFlightsSwitch />
                */}

                {/*Ramp Bookings switch */}
                <RampBookingsSwitch />

                {/*Pre board switch */}
                {dbUser?.details.authority !== "JER" && <PreBoardSwitch />}

                {/* }
                <RemovePaxPrefix />
                */}

                {/*Marshall Task switch */}
                <MarshallTaskSwitch />

                {/*Pre board switch */}
                {/*auto accept unplanned task */}
                <AutoAcceptUnplannedTask />
                {/* Timeline app settings */}
                {/* commented out for now, will be added back later*/}
                {appSettingIataList.includes(dbUser?.details.authority) && <TimelineAppSettings />}
                {/* commented out for now, will be added back later*/}


                {/* {["DUB", "ORK", "BFS", "JER"].includes(dbUser.details.authority) &&
                    <ThirtyMinLayoutSwitch />
                } */}

                {/* dark mode switch */}
                <DarkModeToggle />

                {/* employees Rows per page
                <RowsPerPage />
                */}

                {/* auto check-in location */}
                <AutoCheckInLocation />
            </div>
            {/* QR and buttons */}
            {androidAppVersion?.version && androidAppVersion?.url && (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <QRCode
                        size={100}
                        style={{ height: "150px", maxWidth: "100%", width: "75%", margin: "10px auto" }}
                        value={androidAppVersion.url}
                    />
                    {/* <p style={{ fontSize: "14px", marginBottom: "5px" }}>
                        Latest Version Number <strong>{androidAppVersion.version}</strong>
                    </p> */}
                    <ButtonGroup style={{ gap: '8px', padding: '8px 0' }}>
                        <Button variant="primary" onClick={() => window.open(androidAppVersion.url, "_blank")}>Download</Button>
                        <Button variant={"primary"} onClick={handleCopyURL}>Copy Link </Button>
                    </ButtonGroup>
                </div>
            )}

        </div>
    )
}

export default TimelineSidebar
